import React from 'react'
import styled from 'styled-components'
import withSizes from 'react-sizes'

const ImageContainer = styled.div`
  width: ${(props) => props.width};
`

const ImageFit = ({
  windowWidth,
  windowHeight,
  children,
  width,
  height,
  offsetWidth = 0,
  offsetHeight = 0,
  className,
}) => {
  if (
    offsetWidth &&
    !Number.isInteger(offsetWidth) &&
    offsetWidth.includes('%')
  ) {
    offsetWidth = (windowWidth * Number(offsetWidth.replace('%', ''))) / 100
  }

  const dst = {
    width: windowWidth - offsetWidth,
    height: windowHeight - offsetHeight,
  }

  const src = {
    width,
    height,
  }

  const scale = Math.min(dst.width / src.width, dst.height / src.height)

  const paintingWidth = width * scale

  return (
    <ImageContainer className={className} width={`${paintingWidth}px`}>
      {children}
    </ImageContainer>
  )
}

const mapSizesToProps = ({ width, height }) => {
  return { windowWidth: width, windowHeight: height }
}

export default withSizes(mapSizesToProps)(ImageFit)
